import React from 'react';
import { FaArrowRight } from 'react-icons/fa6';
// import Carousel from './Carousel'; // Import the updated Carousel
import Carousel from './SliderCarousel';
// import img1 from '../../assets/LandingImages/hero.png';
import img2 from '../../assets/LandingImages/hero2.png';
import img3 from '../../assets/LandingImages/hero3.png';
// import img4 from '../../assets/LandingImages/heroReplace.jpg';
// import img5 from '../../assets/LandingImages/hero5.jpg';
import img6 from '../../assets/LandingImages/hero6.png';
import { useNavigate } from 'react-router-dom';
const slides = [
  {
    image: img6,
    heading: 'INDUSTRY ACADEMIA GOVERNMENT CONCLAVE',
    text: 'Join us from December 7 to December 10 for an exciting event focused on bridging the gap between academia and industry through interaction, innovation, technological convergence, and full-time internships.',
  },  
  {
    image: img2,
    heading: 'INNOVATION AND TECHNOLOGY',
    text: 'Empowering the future through technological advancements and innovative solutions for societal growth',
  },
  {
    image: img3,
    heading: 'COLLABORATION FOR A BETTER TOMORROW',
    text: 'Fostering collaboration between sectors to create a sustainable and progressive future',
  }
];


function Hero() {
const navigate = useNavigate();

  const handleClick = () => {
    navigate('/login', 
    {state : {signupActive : true}}) 
  }

  return (
    <Carousel autoSlide={true} autoSlideInterval={4000}>
      {slides.map((s, index) => (
        <div
          key={index}
          id="home"
          className="hero"
          style={{
            backgroundImage: `url(${s.image})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            width: "100%",
            height: "100vh", // Ensure full height for each slide
          }}
        >
          <div className="content justify-end pl-16">
            <h1 className="text-2xl sm:text-4xl lg:text-5xl font-bold">{s.heading}</h1>
            <p className="max-w-xl text-base font-extralight mt-3">{s.text}</p>
            <div className="flex gap-2 mt-3">
              <button
                className="button sign-up flex justify-center items-center gap-1 text-black cursor-pointer"
                onClick={handleClick}
              >
                Sign Up <FaArrowRight />
              </button>
              <button
                className="button learn-more"
                onClick={() => window.location.href = '/#about-us'}
              >
                Learn More
              </button>
            </div>
          </div>
        </div>
      ))}
    </Carousel>
  );
}

export default Hero;
